import React from "react";

const Section2 = ({
    onChange,
    onAddRow,
    onRemoveRow,
    monthly_report_fat_inspection
}) => {
    return (
        <React.Fragment>
            <div className="row">
                <div className="col-md-12 ">
                    <div className="appraisal-report-table-responsive">
                        <table className="assessment-table" cellSpacing={0}>
                            <tbody>
                                {/* Title */}
                                <tr>
                                    <td className="hd-s2" colSpan={4}>
                                        <p>5.　FAT
                                        </p>
                                    </td>
                                </tr>


                                {/* Dynamic Rows */}
                                <tr >
                                    <td className="td-s1 text-center">#</td>

                                    <td className="td-s1">
                                        <p className="s1">Inspection</p>
                                    </td>
                                    <td className="td-s1">
                                        <p className="s1">Result</p>
                                    </td>
                                    <td className="td-s1">
                                        <p className="s1">Evaluation</p>
                                    </td>
                                    <td className="td-s1">
                                        <p className="s1">Feedback to next vessels and/or other shipyard vessels
                                        </p>
                                    </td>
                                    <td className="td-s1">
                                        <p className="s1">Action
                                        </p>
                                    </td>

                                </tr>
                                {/* Dynamic Rows */}
                                {monthly_report_fat_inspection.map((row, index) => (
                                    <tr key={index}>
                                        <td className="td-s1 text-center">{index + 1}</td>

                                        {/* Steel Cutting */}
                                        <td className="tb-input-value">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Inspection "
                                                name="inspection"
                                                value={row.inspection.value}
                                                onChange={(e) => onChange(e, index)}
                                            />
                                        </td>

                                        {/* Block */}
                                        <td className="tb-input-value">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Result"
                                                name="result"
                                                value={row.result.value}
                                                onChange={(e) => onChange(e, index)}
                                            />
                                        </td>

                                        {/* Block */}
                                        <td className="tb-input-value">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Evaluation"
                                                name="evaluation"
                                                value={row.evaluation.value}
                                                onChange={(e) => onChange(e, index)}
                                            />
                                        </td>

                                        {/* Block */}
                                        <td className="tb-input-value">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Feedback"
                                                name="feedback"
                                                value={row.feedback.value}
                                                onChange={(e) => onChange(e, index)}
                                            />
                                        </td>



                                        {/* Remove Row */}
                                        <td className="tb-input-value text-center">
                                            <button
                                                type="button"
                                                style={{
                                                    backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                                    borderColor: "#2b5a7e"
                                                }}
                                                className="btn btn-danger btn-sm"
                                                onClick={() => onRemoveRow(index)}
                                            >
                                                Remove
                                            </button>
                                        </td>
                                    </tr>
                                ))}

                                {/* Add Row */}
                                <tr>
                                    <td colSpan={10}>
                                        <button
                                            type="button"
                                            style={{
                                                backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                                borderColor: "#2b5a7e"
                                            }}
                                            className="btn btn-primary btn-sm ms-2"
                                            onClick={onAddRow}
                                        >
                                            + Add Row
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Section2;
